import { types } from "../types/types";

export const updateModalStatus = (modalstatus) => {
  
  return ({
    type: types.updateModalStatus, // 'f' for failure, '' for success
    payload: modalstatus,
  })};